import handImage from '../../../assets/images/document-guide-hand.webp?url';
import passportCoverImage from '../../../assets/images/passport-cover.webp?url';
import type {DocumentVisual} from './types';
import {preloadDocumentVisualImage, preloadImage} from './useDocumentVisualImage';

function preloadDocumentGuide(visual?: DocumentVisual | null) {
  void preloadImage(handImage);
  void preloadImage(passportCoverImage);
  if (!visual) return;
  preloadDocumentVisualImage(visual.image);
  preloadDocumentVisualImage(visual.other);
}

export {handImage, passportCoverImage, preloadDocumentGuide};
